export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            bonuses: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        bonuses(state) {
            return state.bonuses.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        },
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setBonus(state, bonuses) {
            state.bonuses = bonuses
        },
    },

    actions: {
        async getBonuses(context, payload) {
            context.commit('setLoading', true);
            await axios.post(`${this.state.host}/get-bonuses`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setBonus', res.data.bonuses);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },


        async saveBonus(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.bonus.id != null) {
                url = 'update-bonus';
            } else {
                url = 'add-bonus';
                delete payload.bonus.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                // context.dispatch('getbonuses');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteBonus(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-bonus/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                // context.dispatch('getbonuses');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}
